
document.addEventListener("DOMContentLoaded", function(){
    jQuery('body').on('click','.mds-chng',function (){

        var _this = jQuery(this);
        var qty_element = _this.siblings('.input-text.qty');
        qty_element.trigger('focusin');
        var input_qty = parseFloat(qty_element.val());

        var step = parseFloat(qty_element.attr('step'));
        var min_value = parseFloat(qty_element.attr('min'));
        var max_value = parseFloat(qty_element.attr('max'));

        if(_this.hasClass('mds-plus')){
            var new_qty	  = input_qty + step;

            if(new_qty > max_value && max_value > 0){
                alert('Maximum Quantity: '+max_value);
                return;
            }
        }
        else if(_this.hasClass('mds-minus')){

            var new_qty = input_qty - step;
            if(new_qty === 0){
                return;
            }
            else if(new_qty < min_value){
                return;
            }
            else if(input_qty < 0){
                alert('Invalid');
                return;
            }
        }

        qty_element.val(new_qty)
        jQuery(qty_element).trigger('change');
        jQuery('button[name="update_cart"]').trigger('click');

    });
});